import styled from 'styled-components'
import { images } from '../../../helpers/PreCache'

export const OnDemandLayout = styled.div`
  min-height: calc(100vh - 280px);
  padding-top: 140px;
  padding-bottom: 40px;
  background-image: url(${images.mainBg});
  background-attachment: fixed;
  background-position: top center;
  background-repeat: no-repeat;
  background-size: cover;

  padding-left: 80px;
  padding-right: 80px;
  padding-bottom: 100px;

  @media only screen and (max-width: 600px) {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 60px;
  }

  .content-container {
    display: flex;

    @media only screen and (max-width: 600px) {
      flex-direction: column;
    }
  }
`

export const OnDemandSessionStyle = styled.div`
  .heading {
    text-shadow: 0px 3px 5px #000000;
    color: #e32752;
    margin-bottom: 1em;
    text-align: center;
  }
`

export const OnDemandCardStyle = styled.div`
  position: relative;
  background: black;

  .btn {
    border-radius: 0;
    font-weight: 800;
    letter-spacing: 1px;
  }

  &:hover .overlay {
    opacity: 1;
  }

  &:active .overlay {
    opacity: 1;
  }

  .sessionThumbnail {
    transition: 0.4s ease;
    backface-visibility: hidden;
  }

  .cardPlaceholder {
    transition: 0.4s ease;
    background: black;
    height: 100%;
    min-height: 250px;
  }

  .lockOverlay {
    position: absolute;
    background: rgba(0, 0, 0, 0.4);

    transition: 0.4s ease;
    opacity: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    text-align: center;
    font-size: 0.7em;
    font-weight: 700;
    color: white;

    .lock {
      position: absolute;
      top: 10px;
      right: 10px;
      svg {
        height: 30px;
      }
    }
  }

  .overlay {
    position: absolute;
    background: rgba(0, 0, 0, 0.85);
    z-index: 2;

    transition: 0.4s ease;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    text-align: center;

    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1em;
    padding-left: 16px;
    padding-right: 16px;
    @media (max-width: 768px) {
      position: relative;
      opacity: 1;
      padding: 1em 1em 1em 1em;
      a,
      button {
        font-size: 0.8em;
      }
    }
  }
`

export const OnDemandShowStyle = styled.div`
  min-height: calc(100vh - 140px);
  background-color: black;
  background-image: url(${images.mainBg});
  background-attachment: fixed;
  background-position: top center;
  background-repeat: no-repeat;
  background-size: cover;
  color: #dfdfdf;

  .filterOverlay {
    padding-top: 120px;
    padding-bottom: 80px;
    background: rgba(0, 0, 0, 0.85);
    min-height: calc(100vh - 140px);
    height: 100%;
    width: 100%;
  }

  .gridContainer {
    display: grid;
    grid-template-columns: 1fr 300px;
    gap: 2em;
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  .vimeoContainer {
    padding: 56.25% 0 0 0;
    position: relative;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .footerDetails {
    .title {
      font-weight: 800;
    }
    .presenter {
      font-weight: 600;
      margin-top: 1.5em;
    }
    .presenterDesc {
      margin-top: 1em;
      font-size: 0.85em;
      text-align: justify;
    }
  }

  .rightGrid {
    padding-top: 42px;
    @media (max-width: 768px) {
      padding-top: 0px;
    }
  }
`

export const OnDemandAsides = styled.div`
  border-radius: 5px;
  background-color: #242526;
  padding: 1em;
  margin-bottom: 1em;

  #note {
    font-size: 0.8em;
    width: 100%;
  }

  .asideBtn {
    padding-left: 1.5em;
    padding-right: 1.5em;
    font-size: 0.7em;

    svg {
      height: 12px;
      width: 12px;
      margin-right: 6px;
      margin-bottom: 2px;
    }
  }

  .heading {
    margin-bottom: 1em;
    font-size: 0.85em;

    .headingTitle {
      margin-left: 0.6em;
      font-weight: 600;
    }
  }

  .fileDesc {
    font-size: 0.8em;
    margin-bottom: 1em;
  }
`
